import { useEffect, useState } from "react";
import { API } from "@/config";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

export const LegalPage = ({ endpoint, heading, title }) => {
  const [doc, setDoc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    document.title = `${title} — NightBay`;
    fetch(`${API}/${endpoint}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(setDoc)
      .catch(() => setFailed(true));
  }, [endpoint, title]);

  return (
    <div className="App">
      <Header />
      <main className="nb-shell max-w-[820px] pb-20 pt-[120px]">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-ink3 hover:text-brand">
          <ArrowLeft size={15} aria-hidden="true" /> Back to nightbay.in
        </a>
        <h1 data-testid="legal-heading" className="mt-6 text-4xl sm:text-5xl">
          {heading}
        </h1>

        {doc && (
          <p data-testid="legal-meta" className="mt-4 font-mono text-xs text-ink3">
            Version {doc.version} · Updated {doc.updated_at} · {doc.operator?.legal_name}
          </p>
        )}

        {failed && (
          <p data-testid="legal-error" className="nb-card mt-8 border-err/50 text-sm">
            We couldn't load this document right now. Please email{" "}
            <a href="mailto:support@nightbay.in" className="text-brand underline">
              support@nightbay.in
            </a>{" "}
            and we'll send you a copy.
          </p>
        )}

        <div data-testid="legal-sections" className="mt-10 space-y-8">
          {doc?.sections?.map((s, i) => (
            <section
              key={s.title}
              id={/^F\)|refund/i.test(s.title) ? "refunds" : undefined}
              data-testid={`legal-section-${i}`}
            >
              <h2 className="text-base sm:text-lg">{s.title}</h2>
              <p className="mt-3 whitespace-pre-line text-sm text-ink2 sm:text-base">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};
